module.exports = __webpack_public_path__ + "img/LogoDashboard-3.807d2a2c.svg";